import { API } from "@infra/api";
import { makeDealMatcherUseCases } from "@app/dealMatcher";
import type { Deal } from "@domain/CRM/deal";
import type { Grower } from "@domain/CRM/grower";
import type { Job } from "@domain/CRM/job";
import type { IDeals } from "@ports/deals/IDeals";
import type { IGrowers } from "@ports/growers/IGrowers";
import type { IJobs } from "@ports/jobs/IJobs";
import type { IJobIssues } from "@ports/jobs/IJobIssues";

const jobsApi: Pick<IJobs, "updateField"> = {
	updateField: (id, field, value) => API.Data.Jobs.update.field(id, field, value) as Promise<Job>,
};

const dealsApi: IDeals = {
	getByFilter: (filter) => API.Data.Deals.get.byFilter(filter) as Promise<Deal[]>,
	getByCompany: (company) => API.Data.Deals.get.byCompany(company) as Promise<Deal[]>,
	getByIds: (ids) => API.Data.Deals.get.byIds(ids) as Promise<Deal[]>,
	createMany: (deals) => API.Data.Deals.create.many(deals as Deal[]) as Promise<Deal[]>,
	createOne: (deal) => API.Data.Deals.create.one(deal as Deal) as Promise<Deal>,
};

const growersApi: IGrowers = {
	getByIds: (ids) => API.Data.Growers.get.byIds(ids) as Promise<Grower[]>,
};

const jobIssuesApi: IJobIssues = {
	getAgrian: () => API.Data.Jobs.issues.getAgrian(),
	fixAgrian: (ids) => API.Data.Jobs.issues.fixAgrian(ids),
	getDataSendback: () => API.Data.Jobs.issues.getDataSendback(),
	fixDataSendback: (ids, forceEmail, forceApi) => API.Data.Jobs.issues.fixDataSendback(ids, forceEmail, forceApi),
	getBranchMatcherJobs: () => API.Data.Jobs.issues.getBranchMatcherJobs(),
	getDealMatcherJobs: () => API.Data.Jobs.issues.getDealMatcherJobs(),
	fixDealMatcherJobs: (ids) => API.Data.Jobs.issues.fixDealMatcherJobs(ids),
	fixExeMissionValidationJobs: (ids) => API.Data.Jobs.issues.fixExeMissionValidationJobs(ids),
};

export const dealMatcherUseCases = makeDealMatcherUseCases({ jobIssuesApi, jobsApi, dealsApi, growersApi });
